<template>
  <section class="partner_handbag_hero">
    <div class="big_container">
      <h2 class="card_heading_b" v-html="sanitizeHtml(shopifyData.secSubHeading)" />
      <div class="sec_video">
        <template v-if="shopifyData.checkImage === 'true'">
          <video
            autoplay="true"
            loop="true"
            muted="true"
            controlsList="nodownload"
            disablepictureinpicture
            webkit-playsinline="true"
            playsinline="true"
            preload="none"
          >
            <source :src="shopifyData.videolink" />
          </video>
        </template>
        <template v-else>
          <img
            v-lazy="shopifyData.checkImage.src"
            class="grid_img"
            :placeholder="shopifyData.checkImage.placeholder"
            :alt="shopifyData.checkImage.alt || 'Our Partner Handbag Hero Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Our Partner Handbag Hero Image"
            width=""
            height=""
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.partner_handbag_hero {
  padding: 60px 0px;
}
.sec_video {
  padding: 0 39px;
}
.card_heading_b {
  margin-bottom: 24px;
  text-align: center;
}
.sec_video video {
  display: block;
}

/* ===== RESPONSIVE BREAKPOINTS START ===== */
@media screen and (max-width: 767px) {
  .partner_handbag_hero {
    padding: 44px 0 0;
  }
  .sec_video,
  .big_container {
    padding: 0;
  }
  .card_heading_b {
    margin-bottom: 20px;
  }
}
/* ===== RESPONSIVE BREAKPOINTS END ===== */
</style>
